jQuery(document).on("click", ".cta-camp-lodge", function() {
  var camp = jQuery(this);
  var location = camp.data("location");
  var url = ajaxurl;
  var body = document.body;

  var buttons = document.querySelectorAll(".lets-talk");
  if (camp.hasClass('location-card')) {
    var slideOverlay = camp.find('.campSlideOverlay');
    var slideModal = camp.find('.campSlideIn');
  } else if (camp.parent().parent().hasClass('post-types-preview')) {
    var slideOverlay = $('body').find('.campSlideOverlay');
    var body = document.body;
    var slideModal = $('body').find('.campSlideIn');
  } else {
    var slideOverlay = camp
    .parent()
    .parent()
    .find(".campSlideOverlay");
    var slideModal = camp
      .parent()
      .parent()
      .find(".campSlideIn");
  }
  var lastButton;

  TweenMax.set([slideOverlay], { autoAlpha: 0 });

  function slideIn() {
    lastButton = this;

    var show = new TimelineMax();
    camp.removeClass('cta-camp-lodge');

    if (window.innerWidth < 992) {
      show.to(slideModal, 0.5, {
        transform: "translate(-830px, 0%) matrix(1, 0, 0, 1, 830, 0)"
      });
    } else {
      show.to(slideModal, 0.5, {
        xPercent: -100
      });
    }
    // tl.to(".red", 1, {width: "50%", strictUnits:true});
    show.to(slideOverlay, 0.2, { autoAlpha: 0.4 });
    body.classList.add("no-scroll");
    if (slideOverlay) {
      slideOverlay.on("click", function() {
        var hide = new TimelineMax();

        hide.to(slideModal, 0.5, {
          xPercent: 0
        });
        hide.to(slideOverlay, 0.3, { autoAlpha: 0 });

        body.classList.remove("no-scroll");
        setTimeout(function(){
          camp.addClass('cta-camp-lodge');
        }, 500);
      });
    }
  }

  jQuery.ajax({
    type: "post",
    url: url,
    data: {
      action: "button_click",
      id: location
    },
    success: function(response) {
      slideModal.html(response);
      slideModal.scrollTop(0);
      var swiper = new Swiper(".camps-gallery", {
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
      slideIn();
    }
  });

  return false;
});

jQuery(document).on("click", ".campSlideIn__exit", function(event) {
  var campSlideIn = $(this).parent('.campSlideIn');
  var overlay = campSlideIn.siblings('.campSlideOverlay');
  var body = document.getElementsByTagName('body');
  var camp = $(this).parent().parent();
  event.preventDefault();

  var hide = new TimelineMax();

    if (window.innerWidth < 992) {
      hide.to(campSlideIn, 0.5, {
        transform: "matrix(0, 0, 0, 0, 0, 0)"
      });
    } else {
      hide.to(campSlideIn, 0.5, {
        xPercent: 0
      });
    }

  hide.to(overlay, 0.3, { autoAlpha: 0 });

  body[0].classList.remove('no-scroll');
  setTimeout(function(){
    camp.addClass('cta-camp-lodge');
  }, 500);

});

